import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { CartActions } from './cart.actions';

export class CartStateModel {
  public items?: any = [];
  public shipping?: any = 0;
  public tokenStripe?: string;
}

const defaults = {
  items: [],
  shipping: 0,
  tokenStripe: '',
};

@State<CartStateModel>({
  name: 'cart',
  defaults,
})
@Injectable()
export class CartState {
  @Selector()
  static getList(state: CartStateModel) {
    //

    return state.items;
  }
  @Selector()
  static getShipping(state: CartStateModel) {
    //

    return state.shipping;
  }

  @Action(CartActions.Set)
  add(ctx: StateContext<CartStateModel>, action: CartActions.Set) {
    const state = ctx.getState();
    ctx.setState({ ...state, items: [...state.items, action.item] });
  }

  @Action(CartActions.SetShipping)
  addShipping(ctx: StateContext<CartStateModel>, action: CartActions.SetShipping) {
    const state = ctx.getState();
    ctx.setState({ ...state, shipping: action.item });
  }

  @Action(CartActions.SetTokenStripe)
  addTokenStripe(ctx: StateContext<CartStateModel>, action: CartActions.SetTokenStripe) {
    const state = ctx.getState();
    ctx.setState({ ...state, tokenStripe: action.item });
  }

  @Action(CartActions.Update)
  update(ctx: StateContext<CartStateModel>, action: CartActions.Update) {
    const state = ctx.getState();
    ctx.patchState({ ...state, items: [...state.items] });
  }
  @Action(CartActions.Reset)
  reset(ctx: StateContext<CartStateModel>) {
    const state = ctx.getState();
    ctx.setState({ ...state, items: [], shipping: 0, tokenStripe: '' });
  }

  @Action(CartActions.Delete)
  delete(ctx: StateContext<CartStateModel>, action: CartActions.Delete) {
    let state = ctx.getState();
    let items = state.items.filter((res) => res.id !== action.item);
    ctx.setState({ ...state, items: items });
  }
  // @Action(CartDelete)
  // delete({ getState, setState }: StateContext<CartStateModel>, { payload }: CartAction) {
  //   const state = getState();
  //   setState({ items: [...state.items, payload] });
  // }
}
